import "./works.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ourWorkData } from "../../data/OurWorkData";
import WorkCard from "../../components/work-card/WorkCard";
import ServiceCategories from "../../components/service-categories/ServiceCategories";

function Works() {
  return (
    <div className="works">
      {/* Works Header */}
      <div className="works-header">
        <h1 className="animate__animated animate__fadeIn animate__slow">
          Solutions we crafted to make human lives easier.
        </h1>
        <p className="animate__animated animate__fadeIn animate__slow">
          <span className="bold">Our dedicated services</span> are developed to
          fulfill the whole product cycle. They range from discovery, branding,
          design over to development and continuous improvements in order to
          achieve the best outcome.
        </p>
      </div>

      {/* Works Container */}
      <div className="works-container">
        {ourWorkData.map((work) =>
          <WorkCard key={work.id} data={work} />
        )}
      </div>

      {/* Works Our Services */}
      <div className="works-our-services-section">
        <div className="works-our-services-section-header">
          <h1>
            <span className="bold">Our</span> Services
          </h1>
          <div className="works-our-services-section-header-border"></div>
        </div>

        <div className="works-our-services-categories">
          <ServiceCategories />
        </div>
      </div>
    </div>
  );
}

export default Works;
